import Vue from 'vue'
import Router from 'vue-router'
// 老师个人中心
import Test from '@/components/Test'
import Trem from '@/components/Trem'
import Login from '@/components/Login'
import Examlist from '@/components/teach/Examlist'
import Addplan from '@/components/teach/Addplan'
import Createpaper from '@/components/teach/Createpaper'
import Questionbank from '@/components/teach/Questionbank'
import Questionlist from '@/components/teach/Questionlist'
import Createquestion from '@/components/teach/Createquestion'
import Studentlist from '@/components/teach/Studentlist'

// 学生
import Studentexamlist from '@/components/student/List'
import Examination from '@/components/student/Examination'
const routerRePush = Router.prototype.push
Router.prototype.push = function (location) {

  return routerRePush.call(this, location).catch(error => error)
}

const routerReplace = Router.prototype.replace
Router.prototype.replace = function (location) {
    return routerReplace.call(this, location).catch(error => error)
}
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },{
      path: '/test',
      name: 'Test',
      component: Test
  },{
    path: '/trem',
    name: 'Trem',
    component: Trem
},{
        path: '/examlist',
        name: 'Examlist',
        component: Examlist,
        meta: { requiresAuth: true, role: 1 }
    },{
        path: '/addplan',
        name: 'Addplan',
        component: Addplan,
        meta: { requiresAuth: true, role: 1 }
    },{
        path: '/createpaper',
        name: 'Createpaper',
        component: Createpaper,
        meta: { requiresAuth: true, role: 1 }
    },{
        path: '/questionbank',
        name: 'Questionbank',
        component: Questionbank,
        meta: { requiresAuth: true, role: 1 }
    },{
        path: '/questionlist',
        name: 'Questionlist',
        component: Questionlist,
        meta: { requiresAuth: true, role: 1 }
    },{
        path: '/createquestion',
        name: 'Createquestion',
        component: Createquestion,
        meta: { requiresAuth: true, role: 1 }
    },{
      path: '/studentlist',
      name: 'Studentlist',
      component:Studentlist,
      meta: { requiresAuth: true, role: 1 }
    },{
      path: '/studentexamlist',
      name: 'Studentexamlist',
      component:Studentexamlist,
      meta: { requiresAuth: true, role: 2 }
    },{
      path: '/examination',
      name: 'Examination',
      component:Examination,
      meta: { requiresAuth: true, role: 2 }
    }
    
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  const userinfoStr = localStorage.getItem('userinfo');
  let userType = null;
  
  if (userinfoStr) {
    try {
      const userinfo = JSON.parse(userinfoStr);
      userType = userinfo.type;
    } catch (e) {
      console.error('解析 userinfo 失败:', e);
    }
  }
  
  if (to.meta.requiresAuth) {
    if (!token || !userinfoStr) {
      next({ name: 'Login' });
      return;
    }
    
    const requiredRole = to.meta.role;
    if (requiredRole === 1 && userType !== 1) {
      next({ name: 'Studentexamlist' });
      return;
    }
    
    if (requiredRole === 2 && userType !== 2 && userType !== 0) {
      next({ name: 'Examlist' });
      return;
    }
    
    next();
  } else {
    if (token && userinfoStr && to.name === 'Login') {
      if (userType === 1) {
        next({ name: 'Examlist' });
      } else {
        next({ name: 'Studentexamlist' });
      }
      return;
    }
    next();
  }
});

export default router

